module.exports = __webpack_public_path__ + "img/empty.caf0c15b.png";